import script from "./ChartsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChartsModal.vue?vue&type=style&index=0&id=2ed46a1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed46a1a"]])

export default __exports__